module.exports = __webpack_public_path__ + "img/045-mummy.ba09cfb2.png";